import { render } from "./EditLotNote.vue?vue&type=template&id=cd228862&scoped=true"
import script from "./EditLotNote.vue?vue&type=script&lang=js"
export * from "./EditLotNote.vue?vue&type=script&lang=js"

import "./EditLotNote.vue?vue&type=style&index=0&id=cd228862&lang=css"
import "./EditLotNote.vue?vue&type=style&index=1&id=cd228862&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd228862"]])

export default __exports__